import React, { ReactNode, useContext, useEffect, useState } from 'react'

import { Box, CircularProgress } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'

import { UserContext } from '../../user'
import { APP_PATHS } from '../paths'

export const AuthGuard: React.FC<{ children: ReactNode }> = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { currentUser, isOnboadringCompleted } = useContext(UserContext)

  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setIsLoading(true)

    if (currentUser) {
      // IF LOGGED IN, CHECK EMAIL VERIFICATION & ONBOARDING STATUS
      if (!currentUser.googleAuth && !currentUser.appleAuth && !currentUser.isEmailVerified) {
        // IF EMAIL NOT VERIFIED, REDIRECT TO AUTH PAGE
        navigate(APP_PATHS.auth)
      } else if (!isOnboadringCompleted) {
        // IF ONBOARDING NOT COMPLETED, REDIRECT TO ONBOARDING PAGE
        navigate(APP_PATHS.onboarding)
      }
    } else {
      // IF NOT LOGGED IN, REDIRECT TO AUTH PAGE
      navigate(APP_PATHS.auth)
    }

    setIsLoading(false)
  }, [location, currentUser, isOnboadringCompleted, navigate])

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    )
  }

  return <>{children}</>
}
